<template lang="pug">
div
    el-row(v-if="pessoa && !isSocio", :span="24")
        div.labelStyle(
          v-if="isPf",
          key="pessoa-fisica"
        )
          el-col(:span="12")
            app-display(
              label="Número da certidão de casamento:",
              v-if="temCertidaoCasamento"
              :content="pessoa.pessoaFisica.certidaoCasamento"
              :class = "compararInformacoesPessoa.mudouNumeroCertidaoCasamento ? 'text': '' "
            )
          el-col(:span="12")
            app-display(
              label="Data de casamento:",
              v-if="temCertidaoCasamento"
              :content="formatDate(pessoa.pessoaFisica.dataCasamento)"
              :class = "compararInformacoesPessoa.mudouDataCasamento ? 'text': '' "
            )
          el-col(:span="12")
            app-display(
              :label="temCertidaoCasamento ? 'Cônjuge/Companheiro(a):' : 'Nome:'",
              :content="pessoa.pessoaFisica.nome",
              v-if="pessoa.pessoaFisica.cpf",
              :class = "compararInformacoesPessoa.mudouNome ? 'text': '' "
            )
          el-col(:span="12")
            app-display(
              label="CPF:",
              v-if="pessoa.pessoaFisica.cpf"
              :content="pessoa.pessoaFisica.cpf"
              :class = "compararInformacoesPessoa.mudouCPF ? 'text': '' "
            )
          el-col(:span="12" v-if="!isProcessoFisico")
            app-display(
              label="Apelido:",
              :content="pessoa.pessoaFisica.apelido ? pessoa.pessoaFisica.apelido : '-'",
              v-if="pessoa.pessoaFisica.apelido != null"
              :class = "compararInformacoesPessoa.mudouApelido ? 'text': '' "
            )
          el-col(:span="12" v-if="!isProcessoFisico")
            app-display(
              label="Nome Social:",
              :content="pessoa.pessoaFisica.nomeSocial ? pessoa.pessoaFisica.nomeSocial : '-'",
              v-if="pessoa.pessoaFisica.nomeSocial != null"
              :class = "compararInformacoesPessoa.mudouNomeSocial ? 'text': '' "
            )
          el-col(:span="12" v-if="isProcessoFisico")
            app-display(
              label="Tipo de documento:",
              :content="pessoa.pessoaFisica.tipoDocumento || '-'"
            )
          el-col(:span="12" v-if="isProcessoFisico")
            app-display(
              label="Outros:",
              :content="pessoa.pessoaFisica.outrosTipoDocumento",
              v-if="pessoa.pessoaFisica.tipoDocumento == 'OUTROS'"
            )
          el-col(:span="12")
            app-display(
              label="RG:",
              :content="pessoa.pessoaFisica.rg",
              v-if="pessoa.pessoaFisica.rg"
              :class = "compararInformacoesPessoa.mudouRG ? 'text': '' "
            )
          el-col(:span="12")
            app-display(
              label="Órgão expedidor:",
              :content="getOrgaoExpedidor(pessoa.pessoaFisica.orgaoExpedidor)",
              v-if="pessoa.pessoaFisica.orgaoExpedidor"
              :class = "compararInformacoesPessoa.mudouOrgaoExpedidor ? 'text': '' "
            )
          el-col(:span="12")
            app-display(
              label="Nacionalidade:",
              :content="getGentilico(pessoa.pessoaFisica.nacionalidade)",
              v-if="pessoa.pessoaFisica.nacionalidade"
              :class = "compararInformacoesPessoa.mudouNacionalidade ? 'text': '' "
            )
          el-col(:span="12" v-if="pessoa.pessoaFisica.estadoCivil")
            app-display(
              label="Estado civil:",
              v-if="!isConjuge && !isAmapa",
              :content="getEstadoCivil(pessoa.pessoaFisica.estadoCivil)"
              :class = "compararInformacoesPessoa.mudouEstadoCivil ? 'text': '' "
            )
          el-col(:span="12")
            app-display(
              label="Data de nascimento:",
              :content="data",
              v-if="data"
              :class = "compararInformacoesPessoa.mudouDataNascimento ? 'text': '' "
            )
          el-col(:span="12", v-if="isConjuge")
            app-display(
              label="Data de nascimento:",
              :content="formatDate(pessoa.pessoaFisica.dataNascimento)"
              :class = "compararInformacoesPessoa.mudouDataNascimento ? 'text': '' "
            )
          el-col(:span="12")
            app-display(
              label="Sexo:",
              v-if="pessoa.pessoaFisica.sexo"
              :content="formatarTexto(pessoa.pessoaFisica.sexo)",
            )
          el-col(:span="12")
            app-display(
              label="Naturalidade:",
              :content="getNaturalidade(pessoa.pessoaFisica)",
              v-if="pessoa.pessoaFisica.municipio || pessoa.pessoaFisica.naturalidade"
              :class = "compararInformacoesPessoa.mudouNaturalidade ? 'text': '' "
            )
          el-col(:span="12")
            app-display-multiple(
              label="Telefone(s):"
              :content="formatTelefone(pessoa.telefones)"
              v-if="!isConjuge"
              :class = "compararInformacoesPessoa.mudouTelefones ? 'text': '' "
            )
          el-col(:span="12")
            app-display(
              label="Nome da mãe:",
              :content="pessoa.pessoaFisica.nomeDaMae",
              v-if="pessoa.pessoaFisica.nomeDaMae && !isBahia"
              :class = "compararInformacoesPessoa.mudouNomeDaMae ? 'text': '' "

            )
          el-col(:span="12")
            app-display(
              label="Nome do pai:",
              :content="pessoa.pessoaFisica.nomeDoPai",
              v-if="pessoa.pessoaFisica.nomeDoPai && !isBahia"
              :class = "compararInformacoesPessoa.mudouNomeDoPai ? 'text': '' "

            )
          el-col(:span="12")
            app-display(
              label="Renda familiar:",
              :content="rendaFamiliar.includes('R$') ? rendaFamiliar : `R$ ${rendaFamiliar}`",
              v-if="rendaFamiliar"
              :class = "compararRendaFamiliar ? 'text' :  '' "
            )
          el-col(:span="12")
            app-display(
              label="Profissão:"
              v-if="pessoa.pessoaFisica.profissao && !isBahia"
              :content="pessoa.pessoaFisica.profissao",
            )
          el-col(:span="12")
            app-display(
              label="Possui filho menor de 16 anos:",
              :content="pessoa.pessoaFisica.filhoMenorDe16 ?  'Sim' : 'Não'",
              v-if="pessoa.pessoaFisica.filhoMenorDe16 === true || pessoa.pessoaFisica.filhoMenorDe16 === false"
            )
          el-col(:span="12")
            app-display(
              label="Tempo moradia:",
              v-if="pessoa.pessoaFisica.tempoMoradia"
              :content="`${pessoa.pessoaFisica.tempoMoradia} anos`"
              :class = "compararInformacoesPessoa.mudouTempoMoradia ? 'text': '' "
            )
          el-col(:span="12")
            app-display(
              label="E-mail:"
              :isArray="isBahia"
              :content="isBahia ? pessoa.emails : getEmail(pessoa.email)"
              v-if="!isConjuge && !isProcessoFisico"
              :class = "compararInformacoesPessoa.mudouEmail ? 'text': '' "
            )
          el-col(:span="12" v-if="isBahia")
            app-display(
              label="Profissão:"
              v-if="pessoa.pessoaFisica.profissao"
              :content="pessoa.pessoaFisica.profissao === 'OUTRA' ? pessoa.pessoaFisica.outraProfissao : pessoa.pessoaFisica.profissao"
            )
          el-col(:span="24" v-if="isBahia")
            app-divider(label="Filiação").margin-bottom
            el-col(:span="12").margin-bottom
              app-display(
                label="Nome da Mãe:",
                :content="pessoa.pessoaFisica.nomeDaMae",
                v-if="pessoa.pessoaFisica.nomeDaMae"
                :class = "compararInformacoesPessoa.mudouNomeDaMae ? 'text': '' "
              )
              app-display(
                label="Nome do Pai:",
                :content="pessoa.pessoaFisica.nomeDoPai",
                v-if="pessoa.pessoaFisica.nomeDoPai"
                :class = "compararInformacoesPessoa.mudouNomeDoPai ? 'text': '' "
              )
          div(v-if="dadosInteressadoRr")
            el-col(:span="12")
              app-display(
                label="Possui filho menor de 18 anos de idade?"
                :content="dadosInteressadoRr.possuiFilhoMenor ? 'Sim' : 'Não'"
                v-if="dadosInteressadoRr.possuiFilhoMenor !== undefined"
              )
            el-col(:span="12")
              app-display(
                label="Profissão:"
                :content="dadosInteressadoRr.profissao"
                v-if="dadosInteressadoRr.profissao"
              )
            el-col(:span="12")
              app-display(
                label="Regime empregatício:"
                :content="dadosInteressadoRr.tipoRegimeEmpregaticio"
                v-if="dadosInteressadoRr.tipoRegimeEmpregaticio"
              )
        div(
          v-if="!isPf",
          key="pessoa-juridica"
        )
          el-row(:span="24")
            el-col(:span="12")
              app-display(
                label="CNPJ:",
                :content="pessoa.pessoaJuridica.cnpj"
                :class = "compararInformacoesPessoa.mudouCNPJ ? 'text': '' "
              )
            el-col(:span="12")
              app-display(
                :label="razaoSocialName",
                :content="pessoa.pessoaJuridica.razaoSocial"
                :class = "compararInformacoesPessoa.mudouRazaoSocial ? 'text': '' "
              )
            el-col(:span="12" v-if="!isProcessoFisico")
              app-display-multiple(
                label="Telefone(s):"
                :content="pessoa.telefones"
                :class = "compararInformacoesPessoa.mudouTelefones ? 'text': '' "
              )
            el-col(:span="12" v-if="!isProcessoFisico")
              app-display(
                label="E-mail:",
                :content="pessoa.email",
                v-if="!isConjuge"
                :class = "compararInformacoesPessoa.mudouEmail ? 'text': '' "
              )
            el-col(:span="12" v-if="isProcessoFisico")
              app-display(
                label="Nome do presidente da associação/empresa:",
                :content="pessoa.pessoaJuridica.presidenteAssociacao.nome",
                v-if="!isConjuge"
              )
            el-col(:span="12" v-if="isProcessoFisico")
              app-display(
                label="CPF do presidente da associação/empresa:",
                :content="pessoa.pessoaJuridica.presidenteAssociacao.cpf",
                v-if="!isConjuge"
              )
            el-col(:span="12" v-if="isProcessoFisico")
              app-display(
                label="RG do presidente da associação/empresa:",
                :content="pessoa.pessoaJuridica.presidenteAssociacao.rg || '-'",
                v-if="!isConjuge"
              )
            el-col(:span="12" v-if="isProcessoFisico")
              app-display(
                label="Tipo de documento:",
                :content="pessoa.pessoaJuridica.presidenteAssociacao.tipoDocumento || '-'",
                v-if="!isConjuge"
              )
            el-col(:span="12" v-if="isProcessoFisico")
              app-display(
                label="Outros:",
                :content="pessoa.pessoaJuridica.presidenteAssociacao.outrosTipoDocumento || '-'",
                v-if="!isConjuge && pessoa.pessoaJuridica.presidenteAssociacao.tipoDocumento == 'OUTROS'"
              )
            el-col(:span="12" v-if="isProcessoFisico")
              app-display(
                label="Órgão expedidor:",
                :content="getOrgaoExpedidor(pessoa.pessoaJuridica.presidenteAssociacao.orgaoExpedidor)",
                v-if="!isConjuge"
              )
    el-row(v-if="pessoa && isSocio", :span="24")
        div(
          v-if="pessoa.pessoa.isPessoaFisica",
          key="pessoa-fisica"
        )
          el-col(:span="12")
            app-display(
              label="Nome:",
              :content="pessoa.pessoa.pessoaFisica.nome"
              :class = "compararInformacoesPessoa.mudouNome ? 'text': '' "
            )
          el-col(:span="12")
            app-display(
              label="CPF:",
              :content="pessoa.pessoa.pessoaFisica.cpf"
              :class = "compararInformacoesPessoa.mudouCPF ? 'text': '' "
            )
          el-col(:span="12")
            app-display(
              label="RG:",
              :content="pessoa.pessoa.pessoaFisica.rg",
              v-if="pessoa.pessoa.pessoaFisica.rg"
              :class = "compararInformacoesPessoa.mudouRG ? 'text': '' "
            )
          el-col(:span="12")
            app-display(
              label="Função:",
              :content="getFuncao(pessoa.funcao)",
              v-if="pessoa.funcao"
            )
          el-col(:span="12")
            app-display(
              label="Nacionalidade:",
              :content="getGentilico(pessoa.pessoa.pessoaFisica.nacionalidade)",
              v-if="pessoa.pessoa.pessoaFisica.nacionalidade"
              :class = "compararInformacoesPessoa.mudouNacionalidade ? 'text': '' "
            )
          el-col(:span="12")
            app-display(
              label="E-mail:",
              :content="pessoa.pessoa.email",
              v-if="pessoa.pessoa.email"
              :class = "compararInformacoesPessoa.mudouEmail ? 'text': '' "
            )
          el-col(:span="12")
            app-display(
              label="Estado civil:",
              :content="getEstadoCivil(pessoa.pessoa.pessoaFisica.estadoCivil)"
              :class = "compararInformacoesPessoa.mudouEstadoCivil ? 'text': '' "
            )
          el-col(:span="12")
            app-display(
              label="Data de nascimento:",
              :content="data",
              v-if="data"
              :class = "compararInformacoesPessoa.mudouDataNascimento ? 'text': '' "
            )
          el-col(:span="12")
            app-display(
              label="Órgão expedidor:",
              :content="getOrgaoExpedidor(pessoa.pessoa.pessoaFisica.orgaoExpedidor)",
              v-if="pessoa.pessoa.pessoaFisica.orgaoExpedidor"
              :class = "compararInformacoesPessoa.mudouOrgaoExpedidor ? 'text': '' "
            )
          el-col(:span="12")
            app-display(
              label="Naturalidade:",
              :content="getNaturalidade(pessoa.pessoa.pessoaFisica)",
              v-if="pessoa.pessoa.pessoaFisica.municipio"
              :class = "compararInformacoesPessoa.mudouNaturalidade ? 'text': '' "
            )
          el-col(:span="12")
            app-display(
              label="O sócio é representante legal?",
              :content="pessoa.isSocioRepresentanteLegal ? 'Sim' : 'Não'",
              v-if="pessoa.isSocioRepresentanteLegal !== null && pessoa.isSocioRepresentanteLegal !== ''"
              :class = "compararIsSocioRepresentanteLegal ? 'text': '' "
            )
          el-col(:span="12")
            app-display(
              label="Nome da mãe:",
              :content="pessoa.pessoa.pessoaFisica.nomeDaMae",
              v-if="pessoa.pessoa.pessoaFisica.nomeDaMae"
              :class = "compararInformacoesPessoa.mudouNomeDaMae ? 'text': '' "
            )
          el-col(:span="12")
            app-display-multiple(
              label=":"
              :content="pessoa.pessoa.telefones"
              :class = "compararInformacoesPessoa.mudouTelefones ? 'text': '' "

            )
        div(
          v-if="!pessoa.pessoa.isPessoaFisica",
          key="pessoa-juridica"
        )
          el-row(:span="24")
            el-col(:span="12")
              app-display(
                label="CNPJ:",
                :content="pessoa.pessoa.pessoaJuridica.cnpj"
                :class = "compararInformacoesPessoa.mudouCNPJ ? 'text': '' "

              )
            el-col(:span="12")
              app-display(
                :label="razaoSocialName",
                :content="pessoa.pessoa.pessoaJuridica.razaoSocial"
                :class = "compararInformacoesPessoa.mudouRazaoSocial ? 'text': '' "
              )
            el-col(:span="12")
              app-display-multiple(
                label="Telefone(s):"
                :content="pessoa.pessoa.telefones"
                :class = "compararInformacoesPessoa.mudouTelefones ? 'text': '' "

              )
            el-col(:span="12")
              app-display(
                label="E-mail:",
                :content="pessoa.email",
                v-if="!isConjuge"
                :class = "compararInformacoesPessoa.mudouEmail ? 'text': '' "
              )
</template>

<script>

import moment from 'moment'
import { mapActions } from 'vuex'
import AppDisplay from '../AppDisplay'
import AppDisplayMultiple from '../AppDisplayMultiple'
import gentilicos from '@/constants/gentilico'
import orgaosExpedidores from '@/constants/orgaosExpedidores'
import estados from '@/constants/estados'
import compararReticacoesDefault from '../../utils/pa/compararReticacoesDefault'

export default {

  components: {
    AppDisplay,
    AppDisplayMultiple
  },

  props: {
    pessoa: {
      type: Object,
      default: () => {}
    },
    isConjuge: {
      type: Boolean,
      default: false
    },
    razaoSocialName: {
      type: String,
      default: 'Razão Social'
    },
    isSocioRepresentanteLegal: {
      type: Boolean,
      default: false
    },
    pessoaSocio: {
      type: Object,
      required: false
    },
    isSocio: {
      type: Boolean,
      required: false,
      default: false
    },
    rendaFamiliar: {
      type: String,
      required: false
    },
    compararInformacoesPessoa: {
      type: Object,
      default: compararReticacoesDefault.mudouPessoaDefault
    },
    compararIsSocioRepresentanteLegal: {
      type: Boolean,
      default: false
    },
    compararRendaFamiliar: {
      type: Boolean,
      default: false
    },
    dadosInteressadoRr: {
      type: Object,
      required: false,
      default: () => {}
    },
    isProcessoFisico: {
      type: Boolean,
      required: false,
      default: false
    }
  },

  data () {
    return {
      naturalidade: null
    }
  },

  async created () {
    if (this.pessoa?.pessoaFisica?.naturalidade?.municipio?.id) {
      this.naturalidade = await this.getEstadoAndMunicipioById(this.pessoa?.pessoaFisica?.naturalidade?.municipio?.id)
    }
  },

  computed: {

    isPf () {
      return !!(this.pessoa.isPessoaFisica || this.pessoa.tipo === 'PF' || this.pessoa.pessoaFisica?.cpf)
    },

    data () {
      if (this.isSocio && this.pessoa.pessoa.pessoaFisica.dataNascimento) {
        return moment(this.pessoa.pessoa.pessoaFisica.dataNascimento).format('DD/MM/YYYY')
      }
      if (!this.isSocio && this.pessoa.pessoaFisica.dataNascimento) {
        return moment(this.pessoa.pessoaFisica.dataNascimento).format('DD/MM/YYYY')
      }
    },

    temCertidaoCasamento () {
      return this.pessoa?.pessoaFisica?.certidaoCasamento
    },

    isBahia () {
      return process.env.ESTADO === 'ba'
    },

    isAmapa () {
      return process.env.ESTADO === 'ap'
    }
  },

  methods: {
    ...mapActions({
      getMunicipioById: 'municipios/findMunicipioById'
    }),
    getGentilico (sigla) {
      return gentilicos.filter(item => item.sigla === sigla)[0].gentilico
    },
    async getEstadoAndMunicipioById (numId) {
      return this.getMunicipioById(numId)
    },

    getNaturalidade (pessoa) {
      if (this.naturalidade) {
        return this.naturalidade.nome + ' - ' + this.naturalidade.codigoEstado
      }
      if (pessoa?.municipio) {
        return pessoa.municipio.nome + ' - ' + pessoa.municipio.estadoCod
      } else {
        return pessoa.naturalidade.nome + ' - ' + pessoa.naturalidade.codigoEstado
      }
    },
    formatDate (date) {
      return moment(date).format('DD/MM/YYYY')
    },
    getEmail (email) {
      return email || '-'
    },
    getFuncao (funcao) {
      if (funcao === 'SOCIO') return 'Sócio'
      if (funcao === 'REPRESENTANTE') return 'Representante'
      if (funcao === 'DIRETOR') return 'Diretor'
      if (funcao.includes('REPRESENTANTE')) return 'Representante'
    },
    getOrgaoExpedidor (orgao) {
      const estadosFiltered = estados.filter(item => item.codigo === orgao.estado)
      if (estadosFiltered.length) {
        const orgaoExpedidorNome = orgao.codigo ? orgaosExpedidores().filter(item => item.codigo === orgao.codigo)[0].name : orgao.nome
        return orgaoExpedidorNome + ' - ' + estadosFiltered[0].nome
      }
      return '-'
    },
    getEstadoCivil (props) {
      if (props === null) return '-'
      if (!this.isBahia) {
        if (props === 'SOLTEIRO') return 'Solteiro'
        if (props === 'CASADO') return 'Casado'
        if (props === 'DIVORCIADO') return 'Divorciado'
        if (props === 'SEPARADO') return 'Separado'
        if (props === 'VIUVO') return 'Viúvo'
      } else {
        if (props === 'SOLTEIRO') return 'Solteiro(a)'
        if (props === 'CASADO') return 'Casado(a)'
        if (props === 'DIVORCIADO') return 'Divorciado(a)'
        if (props === 'SEPARADO') return 'Separado(a)'
        if (props === 'VIUVO') return 'Viúvo(a)'
      }
      if (props === 'UNIAO_ESTAVEL') return 'União Estável'
      if (props === 'UNIAO_HOMOAFETIVA') return 'União Homoafetiva'

      return props
    },
    formatTelefone (telefones) {
      if (telefones && telefones.length) {
        return telefones.map(telefone => {
          if (telefone?.numero) {
            return telefone.numero + (telefone.identificacao ? ` - ${telefone.identificacao}` : '')
          } else {
            return telefone
          }
        })
      }
      return ['Nenhum telefone registrado']
    },
    formatarTexto (texto) {
      if (texto) {
        return texto.charAt(0).toUpperCase() + texto.slice(1).toLowerCase()
      } else {
        return '-'
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  p {
    margin-bottom: 1vh;
    font-size: 14px;
    b {
      span{
        font-weight: normal !important;
      }
    }
  }
  >>> .text .text{
    color: #ff0000 !important;
  }
  .margin-bottom {
    margin-bottom: 10px;
  }
  @media (max-width: 780px) {
    .labelStyle {
      display: flex;
      flex-direction: column;
      width: 490px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/informacoesCadastro/InformacoesPessoa.vue